<!-- Deliberately the same shape as a side nav item, so it does not read as a foreign control. -->
<div (click)="open()" role="button" tabindex="0" (keydown.enter)="open()"
  [attr.aria-label]="'NAV-BAR.FEEDBACK' | translate"
  [title]="'NAV-BAR.FEEDBACK' | translate"
  class="h-[42px] rounded-[10px] flex items-center cursor-pointer text-[var(--base-text-alt-dark)] transition-all duration-200 gap-3 shrink-0 hover:bg-[var(--app-hover)] hover:text-[var(--primary-dark)] relative"
  [ngClass]="{
    'w-[42px] justify-center': !sideBarOpened,
    'w-[calc(100%-12px)] px-3 justify-start': sideBarOpened
  }">
  <span class="material-icons text-[26px]">feedback</span>
  <span *ngIf="sideBarOpened" class="text-[13px] font-medium whitespace-nowrap">
    {{ 'NAV-BAR.FEEDBACK' | translate }}
  </span>
</div>
